// extracted by mini-css-extract-plugin
export default {"root":"Button_ellipse_root__lWVp2","icon":"Button_ellipse_icon__BahF2","text":"Button_ellipse_text__UqlLU"};